// extracted by mini-css-extract-plugin
export var centerText = "_ds-8";
export var container = "_ds-0";
export var doughnutContainer = "_ds-7";
export var legend = "_ds-a";
export var legendItemColorDisplay = "_ds-b";
export var legendItemLabel = "_ds-d";
export var legendItemValue = "_ds-c";
export var lg = "_ds-5";
export var maxWidth = "_ds-9";
export var md = "_ds-4";
export var responsive = "_ds-6";
export var sm = "_ds-3";
export var xs = "_ds-2";
export var xxs = "_ds-1";